__turbopack_context__.v({
  "banners": "vdGu6G_banners",
});
